import Loader from "components/Loader";
import MessagePopup from "components/MessagePopup";
import VoidPopup from "components/PreAuth/VoidPopup";
import FilterBar from "components/PreAuth/FilterBar";
import ListTable from "components/PreAuth/ListTable";
import PreAuthCompPopup from "components/PreAuth/PreAuthCompPopup";
import { useEffect, useState } from "react";
import { getPreAuths } from "services/payment";

export default function PreAuth(props: any) {
  const { hotel } = props;
  const defaultPreAuth = {};
  const [loading, setLoading] = useState(false);
  const [fetchCount, setFetchCount] = useState(0);
  const [filter, setFilter] = useState({ notSend: false, filtering: false });
  const [preAuths, setPreAuths] = useState<any>();
  /* use for editPopup component to update info */
  const [preAuth, setPreAuth] = useState(defaultPreAuth);
  const [voidSingle, setVoidSingle] = useState<boolean>(true);
  const [popup, setPopup] = useState<any>({
    preAuthComp: false,
    void: false,
    originalAmount: null,
  });
  const [selectedRecords, setSelectedRecords] = useState<any[]>([]);

  const [queryString, setQueryString] = useState<any>({
    confirmationNumber: undefined,
    checkInDate: undefined,
    createdAt: undefined,
  });

  /* for initial get all records */
  useEffect(() => {
    getData();
  }, [fetchCount]);

  const getData = async () => {
    const query = getQueryString();
    setLoading(true);
    const preAuths = await getPreAuths(query);
    setPreAuths([...preAuths]);
    setLoading(false);
  };

  const getQueryString = () => {
    const allEmpty = Object.values(queryString).every((value) => !value);
    if (allEmpty) return "";

    const queries = Object.keys(queryString)
      .filter((key) => {
        return !!queryString[key];
      })
      .map((key) => {
        return `"${key}":"${queryString[key]}"`;
      })
      .join(",");

    const conditionJson = queries ? `{${queries}}` : "";
    // console.log("conditionJson",conditionJson)
    return `?filter=${conditionJson}`;
  };

  const searchByQueryString = async () => {
    setPreAuths(null);
    await getData();
  };

  return (
    <>
      <MessagePopup />
      <PreAuthCompPopup
        {...{ preAuth, setPreAuth, popup, setPopup, loading, setLoading }}
      />
      <VoidPopup
        {...{
          preAuth,
          setPreAuth,
          popup,
          setPopup,
          loading,
          setLoading,
          selectedRecords,
          setSelectedRecords,
          voidSingle,
        }}
      />
      {loading || preAuths === undefined ? (
        <Loader text="loading..." />
      ) : (
        <>
          <FilterBar
            {...{
              queryString,
              setQueryString,
              searchByQueryString,
              loading,
              setLoading,
              selectedRecords,
              popup,
              setPopup,
              voidSingle,
              setVoidSingle,
              setPreAuths,
            }}
          />
          <ListTable
            selectedRecords={selectedRecords}
            setSelectedRecords={setSelectedRecords}
            hotel={hotel}
            preAuths={preAuths}
            setPreAuth={setPreAuth}
            popup={popup}
            setPopup={setPopup}
            filter={filter}
            setFilter={setFilter}
            fetchCount={fetchCount}
            setFetchCount={setFetchCount}
            queryString={queryString}
            voidSingle={voidSingle}
            setVoidSingle={setVoidSingle}
          />
        </>
      )}
    </>
  );
}
